import classNames from 'classnames';
import { motion } from 'framer-motion';
import { Fragment } from 'react';

import Text from '@/components/Text';

export type HeadlinePart = { id: string; text: string; br?: boolean };

const defaultHeadlineParts: HeadlinePart[] = [
  { id: 'mindpal', text: 'MindPal' },
  { id: 'dash', text: '-' },
  { id: 'delivers', text: 'Delivers' },
  { id: 'talent', text: 'Talent,', br: true },
  { id: 'tech', text: 'Tech' },
  { id: 'and', text: '&' },
  { id: 'traction', text: 'Traction' },
];

type AnimatedHeadlineProps = {
  parts?: HeadlinePart[];
  className?: string;
};

export const AnimatedHeadline = ({
  parts = defaultHeadlineParts,
  className,
}: AnimatedHeadlineProps) => (
  <Text
    variant="display-2"
    as="h1"
    className={classNames('text-center text-neutral-0', className)}
  >
    {parts.map(({ id, text, br }, i) => (
      <Fragment key={id}>
        <motion.span
          initial={{ opacity: 0, x: -20, filter: 'blur(4px)' }}
          animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}
          transition={{ duration: 0.5, delay: i * 0.13, ease: 'easeOut' }}
          className="inline-block"
        >
          {text}
        </motion.span>
        {br ? <br /> : ' '}
      </Fragment>
    ))}
  </Text>
);

const subheadlineParts = [
  { text: 'Your last consultant. We help', bold: false },
  { text: 'raise,', bold: true },
  { text: 'sell', bold: true },
  { text: 'and', bold: false },
  { text: 'build', bold: true },
];

export const AnimatedSubheadline = () => (
  <Text
    variant="h5"
    className="text-center !font-light tracking-normal text-neutral-0"
  >
    {subheadlineParts.map((part, i) => (
      <motion.span
        key={part.text}
        initial={{ opacity: 0, x: -20, filter: 'blur(4px)' }}
        animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}
        transition={{ duration: 0.5, delay: 0.7 + i * 0.12, ease: 'easeOut' }}
        className={classNames('mx-1 inline-block', {
          'font-bolder': part.bold,
        })}
      >
        {part.text}
      </motion.span>
    ))}
  </Text>
);
